export default {
  NAC: "cyan500",
  LAC: "marineGreen300",
  APC: "orchidPink900",
  EUE: "electricBlue500",
  ECA: "marineGreen700",
  MNA: "electricBlue900",
  SSA: "marineGreen900",
  GCH: "crimsonRed300",
  ROW: "grayMid",
  NES: "grayLight",
} as const;
